var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import styled from 'styled-components';
import SpaceMarker from '../components-shared/SpaceMarker';
import TableMarker from '../components-shared/TableMarker';
var HiddenImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: -999999px;\n  left: -9999999px;\n"], ["\n  position: absolute;\n  top: -999999px;\n  left: -9999999px;\n"])));
var NonZoomableContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var ZoomableContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var Image = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  width: ", "px;\n"], ["\n  display: inline-block;\n  width: ", "px;\n"])), function (props) { return props.width; });
// Adapted from https://stackoverflow.com/a/6565988
var calculateRatio = function (iw, ih, cw, ch) {
    var ir = iw / ih;
    var cr = cw / ch;
    var iw2 = cr > ir ? (iw * ch) / ih : cw;
    //const ih2 = cr > ir ? ch : (ih * cw/iw);
    return iw2 / iw;
};
var FloorImageContent = /** @class */ (function (_super) {
    __extends(FloorImageContent, _super);
    function FloorImageContent(props) {
        var _this = _super.call(this, props) || this;
        _this.outerContainerRef = React.createRef();
        _this.imageRef = React.createRef();
        _this.recalculateImageWidth = _this.recalculateImageWidth.bind(_this);
        _this.state = {
            imageSize: { width: 1, height: 1 },
            zoomableContainerSize: { width: 1, height: 1 },
        };
        return _this;
    }
    FloorImageContent.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.recalculateImageWidth);
        this.recalculateImageWidth();
    };
    FloorImageContent.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.currentFloor.image.url !== this.props.currentFloor.image.url ||
            prevProps.zoomLevel !== this.props.zoomLevel) {
            this.recalculateImageWidth();
        }
    };
    FloorImageContent.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.recalculateImageWidth);
    };
    FloorImageContent.prototype.recalculateImageWidth = function () {
        var imageMargin = this.props.imageMargin || 0;
        var outerContainer = this.outerContainerRef.current;
        var image = this.imageRef.current;
        if (!outerContainer || !image || !image.naturalWidth || !image.naturalHeight) {
            return;
        }
        var outerContainerArea = outerContainer.getBoundingClientRect();
        var ratio = this.props.initialFit === 'contain'
            ? calculateRatio(image.naturalWidth, image.naturalHeight, outerContainerArea.width, outerContainerArea.height)
            : outerContainerArea.height / image.naturalHeight;
        var imageSize = {
            width: ratio * this.props.zoomLevel * image.naturalWidth,
            height: ratio * this.props.zoomLevel * image.naturalHeight,
        };
        this.setState({
            imageSize: imageSize,
            zoomableContainerSize: {
                width: Math.max(imageSize.width, outerContainerArea.width) + imageMargin,
                height: Math.max(imageSize.height, outerContainerArea.height) + imageMargin,
            },
        });
    };
    FloorImageContent.prototype.render = function () {
        var _a = this.props, forwardedRef = _a.forwardedRef, currentFloor = _a.currentFloor, tableTags = _a.tableTags, onImageClick = _a.onImageClick, onMarkerClick = _a.onMarkerClick, children = _a.children, imageMargin = _a.imageMargin;
        return (React.createElement(NonZoomableContainer, { ref: this.outerContainerRef },
            React.createElement(HiddenImage, { src: currentFloor.image.url, ref: this.imageRef }),
            React.createElement(ZoomableContainer, null,
                React.createElement("div", { style: {
                        margin: imageMargin ? imageMargin : 0,
                        width: this.state.zoomableContainerSize.width,
                        height: this.state.zoomableContainerSize.height,
                    } },
                    React.createElement("div", { style: {
                            position: 'relative',
                            width: this.state.imageSize.width,
                            height: this.state.imageSize.height,
                        } },
                        React.createElement(Image, { onClick: onImageClick, src: currentFloor.image.url, alt: "floor", ref: forwardedRef, width: this.state.imageSize.width, height: this.state.imageSize.height, onLoad: this.recalculateImageWidth.bind(this) }),
                        currentFloor.spaces.map(function (tag) { return (React.createElement(SpaceMarker, { tag: tag, key: tag.id || Math.random().toString(36).substring(7), onClick: function (e) { return onMarkerClick(e, tag); }, zoom: 1 })); }),
                        tableTags.map(function (tag) { return (React.createElement(TableMarker, { tag: tag, key: tag.id || Math.random().toString(36).substring(7), onClick: function (e) { return onMarkerClick(e, tag); }, zoom: 1 })); }),
                        children)))));
    };
    return FloorImageContent;
}(Component));
export default FloorImageContent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=FloorImageContent.js.map